const docsConfig = {
  Reports: 1,
  Certificates: 2,
  Information: 3,
};
export { docsConfig };
